export const getTotalPages = ({ total, limit }: { total: number; limit: number }) => {
  if (!limit) return 0;

  return Math.ceil(total / limit);
};
